exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".idpagina[_v-6bb84804]{display:inline-block;margin:0 15px;font-size:15px}.setapaginate[_v-6bb84804]{font-size:20px}.pager li>a[_v-6bb84804]{border-radius:3px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-6bb84804&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/pagination/pagination.vue
// module id = 177
// module chunks = 0